import React from "react"
import { Redirect } from "react-router"

import { checkIsSp } from "utils/util"

//トップ
import { Summary } from "components/pages/main/top/summary"
import { Indexes } from "components/pages/main/top/indexes"
import { Foreign } from "components/pages/main/top/foreign"
import { Economics } from "components/pages/main/top/economics"
import { Interest } from "components/pages/main/top/interest"
import { Instrument } from "components/pages/main/top/instrument"
import { BankRate } from "components/pages/main/top/bank_rate"
import { Settlement } from "components/pages/main/top/settlement"

//国内
import { DomesticSummary } from "components/pages/main/domestic/summary"
import { DomesticIndex } from "components/pages/main/domestic/indexes"
import { Ranking } from "components/pages/main/domestic/ranking"
import {
  Future,
  FutureOnly,
  OpOnly,
} from "components/pages/main/domestic/future"
import { Nikkei } from "components/pages/main/domestic/nikkei"
import { IndustryRatio } from "components/pages/main/domestic/IndustryRatio"
import { IPO } from "components/pages/main/domestic/ipo"
import { Data } from "components/pages/main/domestic/data"
import { Trust } from "components/pages/main/domestic/trust"
import { Etf } from "components/pages/main/domestic/etf"

//外株
import {
  Usa,
  China,
  HongKong,
  Indonesia,
  Korea,
  Malaysia,
  Philippine,
  Singapore,
  Taiwan,
  Thai,
  Vietnam,
  Israel,
} from "components/pages/main/foreign"
import { ForeignSummary } from "components/pages/main/foreign/summary"
import { ForeignRanking } from "components/pages/main/foreign/ranking"

//News
import { News } from "components/pages/main/news"

//銘柄検索
import Tool, {
  Search,
  StockBenefit,
  Screening,
} from "components/pages/main/tool"

//登録銘柄
import RegisterBase, {
  Four,
  FourHalf,
  Sign,
  Portfolio,
  Register,
} from "components/pages/main/register"

import { Login } from "components/pages/others/login/login"
import { SSO } from "components/pages/others/sso"

// TechChart
import Chart from "components/atoms/chart"

import { SymbolDetail } from "components/pages/others/symbolDetail"

//マーケット情報（外部画面）
import { ExternalHome } from "components/pages/others/external/home"
import { Market } from "components/pages/others/external/market"

// import { Mypage } from "components/pages/main/mypage"
import { RegisterPropsType } from "components/pages/main/register"

const RegisterChildrenRoutes = (name: string) =>
  checkIsSp()
    ? [
        { path: `/${name}/four`, name: "一覧", component: Four },
        {
          path: `/${name}/change`,
          name: "登録内容変更",
          component: Register,
        },
      ]
    : [
        { path: `/${name}/four`, name: "4本値", component: Four },
        { path: `/${name}/sign`, name: "気配", component: Sign },
        {
          path: `/${name}/portfolio`,
          name: "ポートフォリオ",
          component: Portfolio,
        },
        {
          path: `/${name}/change`,
          name: "登録内容変更",
          component: Register,
        },
      ]

const RegisterChildrenRoutes2 = (name: string) => [
  {
    path: `/${name}/four_half`,
    name: "50株ボード(簡易)",
    component: FourHalf,
  },
  {
    path: `/${name}/four`,
    name: "50株ボード",
    component: (props: RegisterPropsType) => (
      <Four registerWindow={true} {...props} />
    ),
  },
]

export type ToolChildrenRoutesType = Array<{
  path: string
  name: string
  component: React.FC
}>
const ToolChildrenRoutes: ToolChildrenRoutesType = [
  { path: "/tools/search", name: "詳細検索", component: Search },
  {
    path: "/tools/screening",
    name: "スクリーニング",
    component: Screening,
  },
  { path: "/tools/stockholder", name: "株主優待", component: StockBenefit },
]

const FUTUREOP_ROUTES = checkIsSp()
  ? [{ path: "/domestic/future", name: "先物・OP", component: Future }]
  : [
      { path: "/domestic/future_only", name: "先物", component: FutureOnly },
      { path: "/domestic/op_only", name: "OP", component: OpOnly },
    ]

export const MAIN_ROUTES = [
  {
    name: "トップ",
    path: "/top",
    icon: "home",
    component: () => <Redirect to={"/top/summary"} />,
    routes: [
      { path: "/top/summary", name: "ワールドサマリー", component: Summary },
      { path: "/top/index", name: "主要指数", component: Indexes },
      { path: "/top/exchange", name: "為替", component: Foreign },
      { path: "/top/economics", name: "経済指標", component: Economics },
      { path: "/top/bonds", name: "国債", component: Interest },
      { path: "/top/instrument", name: "商品", component: Instrument },
      { path: "/top/bank_rate", name: "政策金利", component: BankRate },
      { path: "/top/settlement", name: "決算", component: Settlement },
    ],
    renderingInMain: true,
  },
  {
    name: "国内株",
    path: "/domestic",
    icon: "library_books",
    component: () => <Redirect to={"/domestic/summary"} />,
    routes: [
      {
        path: "/domestic/summary",
        name: "国内サマリー",
        component: DomesticSummary,
      },
      { path: "/domestic/index", name: "国内指数", component: DomesticIndex },
      { path: "/domestic/ranking", name: "ランキング", component: Ranking },
      { path: "/domestic/future", name: "先物・OP", component: Future },
      {
        path: "/domestic/average",
        name: "日経平均",
        component: Nikkei,
      },
      {
        path: "/domestic/industry",
        name: "業種別",
        component: IndustryRatio,
      },
      { path: "/domestic/ipo", name: "IPO", component: IPO },
      { path: "/domestic/stock", name: "銘柄情報", component: Data },
      { path: "/domestic/credit", name: "証金・信用", component: Trust },
      { path: "/domestic/etf", name: "ETF/REIT/ADR", component: Etf },
    ],
    renderingInMain: true,
  },
  {
    name: "外国株",
    path: "/overseas",
    icon: "language",
    component: () => <Redirect to={"/overseas/summary"} />,
    routes: [
      {
        path: "/overseas/summary",
        name: "外国サマリー",
        component: ForeignSummary,
      },
      {
        path: "/overseas/ranking",
        name: "ランキング",
        component: ForeignRanking,
      },
      { path: "/overseas/us", name: "米国", component: Usa },
      {
        path: "/overseas/hongkong",
        name: "香港",
        component: HongKong,
      },
      { path: "/overseas/china", name: "中国", component: China },
      {
        path: "/overseas/vietnam",
        name: "ベトナム",
        component: Vietnam,
      },
      { path: "/overseas/korea", name: "韓国", component: Korea },
      {
        path: "/overseas/taiwan",
        name: "台湾",
        component: Taiwan,
      },
      {
        path: "/overseas/singapore",
        name: "シンガポール",
        component: Singapore,
      },
      { path: "/overseas/thai", name: "タイ", component: Thai },
      {
        path: "/overseas/malaysia",
        name: "マレーシア",
        component: Malaysia,
      },
      {
        path: "/overseas/indonesia",
        name: "インドネシア",
        component: Indonesia,
      },
      {
        path: "/overseas/philippine",
        name: "フィリピン",
        component: Philippine,
      },
      {
        path: "/overseas/israel",
        name: "イスラエル",
        component: Israel,
      },
    ],
    renderingInMain: true,
  },
  {
    name: "ニュース",
    path: "/news",
    icon: "notifications",
    component: News,
    routes: [],
    renderingInMain: false,
  },
  {
    name: "銘柄検索",
    path: "/tools",
    icon: "search",
    component: () => React.createElement(Tool, { routes: ToolChildrenRoutes }),
    routes: ToolChildrenRoutes,
    renderingInMain: false,
  },
  {
    name: "登録銘柄",
    path: "/register",
    icon: "star_border",
    component: () =>
      React.createElement(RegisterBase, {
        routes: RegisterChildrenRoutes("register"),
      }),
    routes: RegisterChildrenRoutes("register"),
    renderingInMain: false,
  },
  // {
  //   name: "マイページ",
  //   path: "/mypage",
  //   icon: "star_border",
  //   component: Mypage,
  // },
]

export const SymbolPage = [
  {
    name: "登録銘柄",
    path: "/symbol",
    icon: "star_border",
    component: () =>
      React.createElement(RegisterBase, {
        routes: RegisterChildrenRoutes2("symbol"),
      }),
    routes: RegisterChildrenRoutes2("symbol"),
    renderingInMain: false,
  },
]

export const AUTH_ROUTE = {
  login: {
    name: "ログイン",
    path: "/login",
    // icon: "notifications",
    component: Login,
  },
  sso: {
    name: "",
    path: "/sso",
    component: SSO,
  },
  external: {
    home: {
      name: "",
      path: "/external/home",
      component: ExternalHome,
    },
    market: {
      name: "",
      path: "/external/market",
      component: Market,
    },
  },
}

export const TECH_CHART = {
  techChart: {
    name: "テクニカルチャート",
    path: "/chart",
    // icon: "notifications",
    component: Chart,
  },
}

export const SYMBOL_DETAIL = {
  symbolDetail: {
    name: "個別銘柄詳細",
    path: "/SymbolDetail",
    // icon: "notifications",
    component: () => React.createElement(SymbolDetail, { windowMode: true }),
  },
}

export type RouteTypes = typeof MAIN_ROUTES
